<template>
  <div>
    <SmallNav />
    <div class="holder">
      <div class="container pt-3">
        <div class="safe_text_holder">
          <h4 class="safe_text">
            <img src="../assets/images/safe.svg" alt="safe" />
            <span @click="back">Back</span>
          </h4>
          <div class="projects_link">
            <router-link to="/dashboard/safeprojects">
              <h6 class="btn">
                <img src="../assets/images/house-safe.svg" alt="projects" />
                Projects
              </h6>
            </router-link>
          </div>
        </div>

        <div class="form_holder">
          <!-- <div class="project_info_text">
            <h5 class="">
              Project Information
            </h5>
          </div>
          <hr /> -->

          <div class="container">
            <div class="row">
              <div class="col-md-8">
                <div class="row">
                  <div class="col stepper">
                    <div
                      class="stepper-1"
                      :class="[activeStepper === 'active' ? 'activeStep' : '']"
                    ></div>
                    <h5
                      @click="step = 1"
                      :class="[
                        activeStepper === 'active' ? 'activeStepText' : ''
                      ]"
                    >
                      Step 1
                    </h5>
                    <h6
                      @click="step = 1"
                      :class="[
                        activeStepper === 'active' ? 'activeStepText' : ''
                      ]"
                    >
                      Project information
                    </h6>
                  </div>
                  <div class="col stepper">
                    <div
                      class="stepper-2"
                      :class="[
                        activeStepper2 === 'active2' ? 'activeStep' : ''
                      ]"
                    ></div>
                    <h5
                      :class="[
                        activeStepper2 === 'active2' ? 'activeStepText' : ''
                      ]"
                    >
                      Step 2
                    </h5>
                    <h6
                      :class="[
                        activeStepper2 === 'active2' ? 'activeStepText' : ''
                      ]"
                    >
                      Project funding
                    </h6>
                  </div>
                </div>
                <form v-if="step === 1">
                  <div class="form-group">
                    <label for="type">Project Type</label>
                    <select
                      :disabled="rentSchdule"
                      class="form-control"
                      id="type"
                      v-model="projecttypeid"
                    >
                      <option selected disabled value="">--Select--</option>
                      <option
                        v-for="(item, index) in projectTypes"
                        :key="index"
                        :value="item.id"
                        >{{ item.name }}</option
                      >
                      <option value="0">Others</option>
                    </select>
                  </div>
                  <div class="form-group" v-if="projecttypeid == '0'">
                    <label for="specify">Specify</label>
                    <input
                      type="text"
                      class="form-control"
                      id="specify"
                      name="title"
                      v-bind="specifytype"
                      placeholder="specify the project type"
                    />
                  </div>
                  <div class="form-group">
                    <label for="type"
                      >Do you want to add project handler?</label
                    >
                    <select
                      @change="revertHandler"
                      class="form-control"
                      id="handler"
                      v-model="requestHandlerOption"
                    >
                      <option selected disabled :value="null"
                        >--Select--</option
                      >
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                  </div>
                  <div
                    class="form-group panel-input" id="org" ref="orgg"
                    v-if="requestHandlerOption == 'yes'"
                  >
                    <label for="">Project Handler</label>
                    <input
                      @focus="runOption($event)"
                      @keyup="filterPartner(prohandler)"
                      ref="openPanel"
                      type="text"
                      class="form-control"
                      id="panel"
                      name="title"
                      v-model="prohandler"
                      placeholder="Select project handler or search for one"
                    />
                    <span @click="openOption = false" v-if="openOption">
                      <i class="fa fa-chevron-up"></i>
                    </span>
                    <span @click="openOption = true" v-if="!openOption">
                      <i class="fa fa-chevron-down"></i>
                    </span>
                    <div v-if="openOption" class="option-list">
                      <div
                        class="handler-list"
                        v-for="(item, index) in partners"
                        :key="index"
                      >
                        <li
                          :class="[
                            item.firstname === prohandler ? 'activeHandler' : ''
                          ]"
                          @click="selectPanel(item.firstname, item.id)"
                        >
                          {{ item.firstname }}
                        </li>
                      </div>
                      <div class="add-project-handler-trigger">
                        <p data-toggle="modal" data-target="#addprojecthandler">
                          <small>+</small> Add project handler
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    class="form-group"
                    v-if="requestHandlerOption == 'yes' && prohandler != ''"
                  >
                    <label for="type">Project</label>
                    <select
                      class="form-control"
                      id="handler"
                      v-model="handlerServiceId"
                    >
                      <option selected disabled value="">--Select--</option>
                      <option
                        v-for="(item, index) in servicesPartner"
                        :key="index"
                        :value="item.safeservice_id"
                        >{{ item.service }}</option
                      >
                      <!-- <option value="no">No</option> -->
                    </select>
                  </div>

                  <!-- modal to add partners starts -->
                  <div
                    class="modal fade"
                    id="addprojecthandler"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="exampleModalCenterTitle"
                    aria-hidden="true"
                  >
                    <div
                      class="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div class="modal-content addHandlerModalContent">
                        <div
                          class="closeProjectHandler"
                          style="border-radius: 20px 20px 0 0;"
                        >
                          <h6>Add project handler</h6>
                          <small
                            data-dismiss="modal"
                            aria-label="Close"
                            @click="
                              closedPaystack;
                              fundLoaderBlue = false;
                            "
                            >x</small
                          >
                        </div>
                        <div class="modal-body">
                          <form>
                            <div class="form-group">
                              <label for="partnername">Project Handler</label>
                              <input
                                type="text"
                                class="form-control"
                                id="partnername"
                                placeholder="Handler's name"
                                v-model="partnername"
                              />
                            </div>
                            <div class="form-group">
                              <label for="partnerservice"
                                >Handler's Services</label
                              >
                              <input
                                type="text"
                                class="form-control"
                                id="partnerservice"
                                placeholder="Services"
                                v-model="partnerservice"
                              />
                            </div>
                            <div class="form-group">
                              <label for="partneremail">Handler's Email</label>
                              <input
                                type="email"
                                class="form-control"
                                id="partneremail"
                                placeholder="Email"
                                v-model="partneremail"
                              />
                            </div>
                            <div class="form-group">
                              <label for="partnerphone">Handler's Phone</label>
                              <input
                                type="number"
                                class="form-control"
                                id="partnerphone"
                                placeholder="Phone number"
                                v-model="partnerphone"
                              />
                            </div>

                            <div class="form-group add-handler-btn">
                              <button
                                class="btn btn-block"
                                @click.prevent="addNewHandler"
                              >
                                SAVE
                                <i
                                  class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                                  v-if="handlerLoader"
                                ></i>
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- Modal to add partners ends -->

                  <div class="form-group">
                    <label for="projectdetails">Project Details</label>
                    <textarea
                      type="text"
                      class="form-control pro_details"
                      id="projectdetails"
                      rows="5"
                      v-model="projectdetails"
                      placeholder="Enter a detailed details of your project"
                    >
                    </textarea>
                  </div>
                </form>
                <form v-if="step === 2">
                  <div class="form-group">
                    <label for="title">Title</label>
                    <input
                      :disabled="rentSchdule"
                      type="text"
                      class="form-control"
                      id="title"
                      name="title"
                      placeholder="Enter project title"
                      v-model="title"
                      maxlength="50"
                    />
                  </div>

                  <div class="form-group">
                    <label for="">Allocation/Amount/Budget</label>
                    <div class="allocation_wrap">
                      <div class="text-justify radio_wrap-2">
                        <div class="form-check form-check-inline">
                          <input

                            class="form-check-input"
                            type="radio"
                            name="allocation"
                            id="fixed"
                            v-model="amountType"
                            value="fixed"
                          />
                          <label
                            class="form-check-label radio-label"
                            for="fixed"
                            >Fixed Amount</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                           :disabled="rentSchdule"
                            v-model="amountType"
                            class="form-check-input"
                            type="radio"
                            name="allocation"
                            id="range"
                            value="range"
                          />
                          <label
                            class="form-check-label radio-label"
                            for="range"
                            >Range</label
                          >
                        </div>
                      </div>

                      <div
                        class="form-group pl-4 pr-4"
                        v-if="amountType === 'fixed'"
                      >
                        <!-- onfocus="(this.type='text')" -->
                        <input
                         :disabled="rentSchdule"
                          onfocus="(this.type='text')"
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                          class="form-control"
                          id="fixedamount"
                          name="fixedamount"
                          placeholder="Fixed Amount"
                          v-model="amountforfixed2"
                          maxlength="11"
                        />
                      </div>
                      <div
                        class="form-group range_input pl-4 pr-4"
                        v-if="amountType === 'range'"
                      >
                        <input
                          onfocus="(this.type='text')"
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                          maxlength="11"
                          type="number"
                          class="form-control"
                          id="min"
                          name="start"
                          placeholder="Minimun"
                          v-model="minamountforrange2"
                        />
                        <input
                          onfocus="(this.type='text')"
                          oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                          maxlength="11"
                          type="number"
                          class="form-control"
                          id="max"
                          name="ends"
                          placeholder="Maximum"
                          v-model="maxamountforrange2"
                        />
                      </div>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for=""
                      >How would you like to fund this project?</label
                    >
                    <div class="allocation_wrap">
                      <div class="text-justify radio_wrap-2">
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="fundtype"
                            id="direct"
                            v-model="fundtype"
                            value="fromsafe"
                          />
                          <label
                            class="form-check-label radio-label"
                            for="direct"
                            >From SAFE</label
                          >
                        </div>
                        <div class="form-check form-check-inline">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="fundtype"
                            id="atwill"
                            v-model="fundtype"
                            value="atwill"
                          />
                          <label
                            class="form-check-label radio-label"
                            for="atwill"
                            >Fund at will</label
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group" v-if="fundtype != 'atwill'">
                    <label for="date">Select Frequency</label>
                    <select
                      class="form-control"
                      id="projecttype"
                      v-model="modeofsafing"
                    >
                      <option selected disabled value=""
                        >--Select--</option
                      >
                      <option
                        v-for="(item, index) in modeOfSafeProject"
                        :key="index"
                        :value="item.id"
                        >{{ item.name }}</option
                      >
                    </select>
                  </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="startdate">Start Date</label>
                        <input
                          type="date"
                          class="form-control"
                          id="startdate"
                          v-model="startdate"
                        />
                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="enddate">End Date</label>
                        <input
                          :disabled="startdate === '' || startdate == null"
                          type="date"
                          class="form-control"
                          id="enddate"
                          v-model="enddate"
                          @change="calculateDate"
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div
                class="col-md-4"
                v-if="
                  ((maxamountforrange != '' && enddate != '') ||
                    (amountforfixed != '' && enddate != '')) &&
                    (enddate != '' || enddate != null) &&
                    (amountforfixed != null || maxamountforrange != null)
                "
              >
                <div class="goal_target2">
                  <div class="goal_holder2">
                    <img src="../assets/images/target.svg" alt="goal" />
                    <span>Project Goal</span>
                    <h1 v-if="amountType === 'fixed'">
                      <small v-if="amountforfixed != ''">&#8358;</small
                      >{{ Number(amountforfixed).toLocaleString() }}
                    </h1>
                    <h1 v-else>
                      <small v-if="maxamountforrange != ''">&#8358;</small
                      >{{ Number(maxamountforrange).toLocaleString() }}
                    </h1>
                  </div>
                  <!-- v-if="enddate != '' || enddate != null" -->
                  <div class="breakdown-amount">
                    <h6>Breakdown</h6>
                    <div class="row m-0" style="background: #F8F8F8;">
                      <div class="col p-0">
                        <small class="duration">
                          Daily
                        </small>
                      </div>
                      <div class="col p-0">
                        <small
                          class="duration-amount"
                          v-if="amountType === 'fixed'"
                        >
                          &#8358;{{
                            Number(amountforfixed / daily).toLocaleString()
                          }}
                        </small>
                        <small
                          class="duration-amount"
                          v-if="amountType === 'range'"
                        >
                          &#8358;{{
                            Number(maxamountforrange / daily).toLocaleString()
                          }}
                        </small>
                      </div>
                    </div>
                    <div class="row m-0">
                      <div class="col p-0">
                        <small class="duration">
                          Weekly
                        </small>
                      </div>
                      <div class="col p-0">
                        <small
                          class="duration-amount"
                          v-if="amountType === 'fixed'"
                        >
                          &#8358;{{
                            Number(amountforfixed / weekly).toLocaleString()
                          }}
                        </small>
                        <small
                          class="duration-amount"
                          v-if="amountType === 'range'"
                        >
                          &#8358;{{
                            Number(maxamountforrange / weekly).toLocaleString()
                          }}
                        </small>
                      </div>
                    </div>
                    <div class="row m-0" style="background: #F8F8F8">
                      <div class="col p-0">
                        <small class="duration">
                          Monthly
                        </small>
                      </div>
                      <div class="col p-0">
                        <small
                          class="duration-amount"
                          v-if="amountType === 'fixed'"
                        >
                          &#8358;{{
                            Number(amountforfixed / monthly).toLocaleString()
                          }}
                        </small>
                        <small
                          class="duration-amount"
                          v-if="amountType === 'range'"
                        >
                          &#8358;{{
                            Number(maxamountforrange / monthly).toLocaleString()
                          }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="trigger-bittons">
              <button @click="step = 1" v-if="step == 2" class="btn prev">Previous</button>
              <button class="btn continue-later" @click="saveDataToContinue">
                Continue later
                <i
                  class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                  v-if="saving"
                ></i>
              </button>
              <button class="btn next" @click="nextStep()" v-if="step == 1">
                Next
              </button>
              <button class="btn next" @click="addProject" v-if="step == 2">
                Submit
                <i
                  class="fa fa-spinner fa-spin ml-3 f-12 btn-loader"
                  v-if="loader"
                ></i>
              </button>
              <!-- <p @click="step = 1" v-if="step == 2">Back to step 1</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SmallNav from "./SmallNav";
import { Service } from "../store/service";
const Api = new Service();
import $ from "jquery";
import moment from "moment";
import Vue from "vue";

export default {
  name: "SafeNewProject",
  components: {
    SmallNav
  },
  data() {
    return {
      loader: false,
      saving: false,
      rentSchdule: false,
      amountType: "fixed",
      fundtype: "fromsafe",
      modeOfSafeProject: "",
      daysofweek: "",
      futherInfo: "",
      modeofsafing: "",
      projectdetails: "",
      projectid: "",
      projecttypeid: "",
      startdate: "",
      enddate: "",
      amountforfixed: "",
      amountforfixed2: "",
      title: "",
      maxamountforrange: "",
      minamountforrange: "",
      maxamountforrange2: "",
      minamountforrange2: "",
      projectTypes: "",
      user: "",
      daily: "",
      monthly: "",
      weekly: "",
      serverDateTime: "",
      saveDataServer: "",
      requestHandlerOption: "no",
      projecthandler: "",
      handlerServiceId: "",
      step: 1,
      activeStepper: "",
      activeStepper2: "",
      openOption: false,
      handlerLoader: false,
      prohandler: "",
      partnerphone: "",
      partneremail: "",
      partnername: "",
      partnerservice: "",
      partners: [],
      handlerId: "",
      serviceId: "",
      servicesPartner: [],
      specifytype: "",
      propertydetails: ""
    };
  },
  watch: {
    // step: function() {
    //   this.finalStep();
    //   console.log("step1", this.activeStepper, "step2", this.activeStepper2);
    // },
    amountforfixed2: function(newValue) {
      const result = newValue
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => (this.amountforfixed2 = result));
      this.amountforfixed = this.amountforfixed2.split(",").join("");
    },
    maxamountforrange2: function(newValue) {
      const result = newValue
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => (this.maxamountforrange2 = result));
      this.maxamountforrange = this.maxamountforrange2.split(",").join("");
    },
    minamountforrange2: function(newValue) {
      const result = newValue
        .replace(/\D/g, "")
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      Vue.nextTick(() => (this.minamountforrange2 = result));
      this.minamountforrange = this.minamountforrange2.split(",").join("");
    }
    // amountforfixed: function() {
    //   Vue.nextTick(() => this.amountforfixed);
    // },
    // maxamountforrange: function() {
    //   Vue.nextTick(() => this.maxamountforrange);
    // },
    // enddate: function() {
    //   Vue.nextTick(() => this.enddate);
    // }
  },
  mounted() {
    this.user = JSON.parse(localStorage.getItem("shelta-user"));
    this.fetchModeOfProjectForDebit();
    this.fetchProjectTypes();
    this.fetchPartners();
    if (localStorage.getItem("_safeprojectdata")) {
      this.getProjectData();
    }
    if (this.startdate != "" && this.enddate != "") {
      this.calculateDate();
    }
    this.getServerDateTime();
    // this.getCurrentDay();
    this.getSavedData();
    if (localStorage.getItem("scheduleSafe")) {
      this.fetchProperty();
    } else {
      this.title = "";
      this.projecttypeid = "";
      this.price = "";
      this.rentSchdule = false;
    }
    // this.nextStep();
   if (this.requestHandlerOption == "yes") {
    document.addEventListener("click", this.handleClickOutside);
   }
  },
  // beforeMount() {
  //   this.getCurrentDay()
  // },
  // created() {
  //   // this.$root.$refs.A = this;
  //   // this.getCurrentDay()
  // },
  beforeDestroy() {
    // Remove the click event listener when the component is about to be destroyed
    document.removeEventListener("click", this.handleClickOutside);
  },

  methods: {
    filterPartner(string) {
      // console.log("prohandler", this.prohandler);
      const regexp = new RegExp(string, "i");
      const filtered = this.partners.filter(x => regexp.test(x.firstname));
      this.partners = filtered;
      if (this.partners.length == 0 || this.prohandler === "") {
        this.fetchPartners();
      }
    },
    handleClickOutside(event) {
      const targetElement = this.$refs.orgg;
      if (!targetElement.contains(event.target)) {
        // The click occurred outside the target element
        // Put your code here to handle clicks outside the element
        this.openOption = false;
      }
    },
    runOption(event) {
      document.addEventListener("click", this.handleClickOutside);
      const inputBox = this.$refs.openPanel;
      // console.log("reffffff", inputBox);
      this.openOption = true;
      if (!inputBox.contains(event.target)) {
        this.openOption = false;
      }
    },
    selectPanel(name, id) {
      this.prohandler = name;
      this.handlerId = id;
      this.openOption = false;
      this.fetchPartnerServices(id);
    },
    back() {
      this.$router.go(-1);
    },
    revertHandler() {
      if (this.requestHandlerOption == "no") {
        this.handlerId = "";
        this.handlerServiceId = "";
        this.prohandler = "";
        // console.log("handler", this.prohandler);
      } else {
        // console.log("handler", this.prohandler);
      }
    },
    async addNewHandler() {
      this.handlerLoader = true;
      const validRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!validRegex.test(this.partneremail)) {
        this.handlerLoader = false;
        return this.$store.commit("setApiFailed", "Invalid Email address!");
      }
      if (this.partnername == "") {
        return this.$store.commit("setApiFailed", "Name is required");
      }
      if (this.partnerservice == "") {
        return this.$store.commit("setApiFailed", "Select services");
      }
      if (this.partneremail == "") {
        return this.$store.commit("setApiFailed", "Email is required");
      }
      if (this.partnerphone == "") {
        return this.$store.commit("setApiFailed", "Phone number is required");
      }
      try {
        // createpartnerwhilecreatingproject2
        await Api.postRequest(`createpartnerwhilecreatingproject`, {
          phone: this.partnerphone,
          email: this.partneremail,
          partnername: this.partnername,
          service: this.partnerservice
        })
          .then(res => {
            // console.log("new handler", res);
            this.handlerLoader = false;
            if (res.data.success) {
              this.fetchPartners();
              return this.$store.commit("setApiSuccess", "Success");
            }
            if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            console.log(err);
            this.handlerLoader = false;
          });
      } finally {
        // console.log("closed");
      }
    },
    async fetchProperty() {
      const id = localStorage.getItem("scheduleSafe");
      try {
        await Api.getRequest(`fetchpropertybyid/${id}`)
          .then(res => {
            if (res.data.success) {
              this.rentSchdule = true;
            // console.log("response on prop", res);
              this.propertydetails = res.data.property;
              this.title = res.data.property.title;
              this.projecttypeid = 1;
              this.amountforfixed2 = res.data.property.price;
            }
            if (res.data.error) {
              this.$store.commit("setApiFailed", res.data.error);
            }
            // setTimeout(() => {
            //   this.amountforfixed2 = res.data.property.price;
            // }, 2000);
          })
          .catch(err => {
            console.log(err);
            this.rentSchdule = false;
          });
      } finally {
        // console.log("connection closed");
      }
    },
    async fetchPartners() {
      try {
        await Api.getRequest(`fetchpartersforprojecthandling`)
          .then(res => {
            // console.log("parners", res);
            if (res.data.success) {
              this.partners = res.data.partners;
            }
            if (res.data.error) {
              this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            console.log(err);
          });
      } finally {
        // console.log("closed");
      }
    },
    async fetchPartnerServices(id) {
      try {
        await Api.getRequest(`getservicesbypartnerid/${id}`)
          .then(res => {
            // console.log("parners services", res);
            if (res.data.success) {
              this.servicesPartner = res.data.partnerservices;
            }
            if (res.data.error) {
              this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            console.log(err);
          });
      } finally {
        // console.log("closed");
      }
    },
    getServerDateTime() {
      Api.getRequest(`getservertime`).then(res => {
        // console.log("Server time", res.data.date);
        this.serverDateTime = res.data.date;
      });
    },
    getCurrentDay() {
      const today = new Date().toISOString().split("T")[0];
      document.getElementById("startdate").setAttribute("min", today);
      document.getElementById("enddate").setAttribute("min", today);

      // const current = new Date();
      // current.setMonth(current.getMonth() + 3);
      // const x = new Date(current).toISOString().split("T")[0];
      // document.getElementById("enddate").setAttribute("max", x);
    },
    calculateDate() {
      // Weekly pick
      const oneweek = 1000 * 60 * 60 * 24 * 7;
      const d1 = new Date(this.startdate).getTime();
      const d2 = new Date(this.enddate).getTime();
      const difference = Math.abs(d2 - d1);
      this.weekly = Math.floor(difference / oneweek);
      // console.log("weeks", Math.floor(difference / oneweek), this.weekly);
      // return Math.floor(difference / oneweek);

      // Daily pick
      const day = 1000 * 60 * 60 * 24;
      const date1 = new Date(this.startdate).getTime();
      const date2 = new Date(this.enddate).getTime();
      const difference2 = Math.abs(date2 - date1);
      this.daily = Math.floor(difference2 / day);
      // console.log("Days", Math.floor(difference2 / day), this.daily);
      // return Math.floor(difference_ms / ONE_WEEK);

      // Monthly pick
      let months;
      months =
        (new Date(this.enddate).getYear() -
          new Date(this.startdate).getYear()) *
        12;
      months -= new Date(this.startdate).getMonth();
      months += new Date(this.enddate).getMonth();
      this.monthly = months <= 0 ? 0 : months;

      // if (this.startdate === this.enddate) {
      //   this.$store.commit("setApiFailed", "Start date and end date should not be the same");
      // }
    },
    fetchProjectTypes() {
      Api.getRequest(`fetchsafeprojecttypes`).then(res => {
        // console.log("project Types", res);
        if (res.data.success) {
          this.projectTypes = res.data.safeprojecttypes;
        } else {
          this.$store.commit("setApiFailed", res.data.error);
        }
      });
    },
    fetchModeOfProjectForDebit() {
      Api.getRequest(`fetchmodeofsafingforprojects`).then(res => {
        // console.log("Mode of project debit", res);
        if (res.data.success) {
          this.modeOfSafeProject = res.data.modes;
        } else {
          this.$store.commit("setApiFailed", res.data.error);
        }
      });
    },
    nextStep() {
      if (this.projecttypeid == 0) {
        if (this.specifytype == "") {
          return this.$store.commit("setApiFailed", "Specify project type");
        }
      }
      if (this.requestHandlerOption == "yes") {
        if (this.handlerServiceId === "" || this.handlerId === "") {
          return this.$store.commit("setApiFailed", "Fill required fields");
        }
        if (this.projectdetails === "" || this.projecttypeid === "") {
          return this.$store.commit("setApiFailed", "Fill required fields");
        } else {
          this.activeStepper = "active";
          this.step = 2;
          setTimeout(() => {
            this.getCurrentDay();
          }, 2000);
        }
      } else if (this.requestHandlerOption == "no") {
        if (this.projectdetails === "" || this.projecttypeid === "") {
          return this.$store.commit("setApiFailed", "Fill required fields");
        } else {
          this.activeStepper = "active";
          this.step = 2;
          // this.getCurrentDay();
          setTimeout(() => {
            this.getCurrentDay();
          }, 2000);
        }
      }
    },
    finalStep() {
      console.log("chnaged", this.activeStepper);
      if (this.amountType === "fixed") {
        if (this.amountforfixed === "") {
          this.loader = false;
          return this.$store.commit("setApiFailed", "Enter fixed amount");
        }
      }
      if (this.amountType === "range") {
        if (this.maxamountforrange === "") {
          this.loader = false;
          return this.$store.commit("setApiFailed", "Enter Maximum range amount");
        }
      }
      if (this.fundtype === "fromsafe") {
        if (this.modeofsafing === "") {
          this.loader = false;
          return this.$store.commit("setApiFailed", "Select Frequency");
        }
      } else {
        this.activeStepper = "active2";
      }
      // console.log("Active state", this.activeStepper);
    },
    async addProject() {
      this.loader = true;
      if (this.amountType === "fixed") {
        if (this.amountforfixed === "") {
          this.loader = false;
          return this.$store.commit("setApiFailed", "Fill required fields");
        }
      }
      if (this.amountType === "range") {
        if (this.maxamountforrange === "") {
          this.loader = false;
          return this.$store.commit("setApiFailed", "Fill required fields");
        }
      }
      if (this.fundtype === "fromsafe") {
        if (this.modeofsafing === "") {
          this.loader = false;
          return this.$store.commit("setApiFailed", "Fill required fields");
        }
      }
      if (this.requestHandlerOption == "yes") {
        if (this.handlerServiceId === "" || this.handlerId === "") {
          return this.$store.commit("setApiFailed", "Fill required fields");
        } else {
          this.activeStepper = "active2";
        }
      }
      if (
        this.title === "" ||
        // this.modeofsafing === "" ||
        this.startdate === "" ||
        this.enddate === "" ||
        this.projectdetails === ""
      ) {
        this.loader = false;
        return this.$store.commit("setApiFailed", "Fill required fields");
      }
      if (parseInt(this.minamountforrange) > parseInt(this.maxamountforrange)) {
        this.loader = false;
        return this.$store.commit(
          "setApiFailed",
          "Minimum range can't be greater than maximum range"
        );
      }
      if (this.monthly < 3) {
        this.loader = false;
        return this.$store.commit(
          "setApiFailed",
          "Project end date must be more that three months"
        );
      }
      let submitOption;
      if (this.saveDataServer.project == null) {
        if (!this.rentSchdule) {
          this.property_id = null;
          submitOption = `createnewproject`;
        } else {
          submitOption = `schedulerentwithsafe`;
        }
      } else {
        submitOption = `finalsubmitsaveddataforproject`;
      }
      try {
        if (this.amountType === "fixed") {
          // const formattedAmount1 = this.amountforfixed.split(",").join("");
          this.maxamountforrange = null;
          this.minamountforrange = null;
        }
        if (this.amountType === "range") {
          this.amountforfixed = null;
        }
        this.activeStepper2 = "active2";
        await Api.postRequest(`${submitOption}`, {
          property_id: this.propertydetails.id,
          user_id: this.user.id,
          title: this.title,
          amounttype: this.amountType,
          projecttypeid: this.projecttypeid,
          projectdetails: this.projectdetails,
          modeofsafing: this.modeofsafing,
          fundtype: this.fundtype,
          projectid: this.projectid,
          startdate: this.startdate,
          enddate: this.enddate,
          handler_id: this.handlerId,
          specifytype: this.specifytype,
          service_id: this.handlerServiceId,
          amountforfixed: Number(this.amountforfixed),
          maxamountforrange: this.maxamountforrange,
          minamountforrange: this.minamountforrange
        })
          .then(res => {
            // console.log("New project", res);
            this.loader = false;
            if (res.data.success) {
              this.$store.commit("setApiSuccess", "Success");
              localStorage.removeItem("_safeprojectdata");
              if (localStorage.getItem("scheduleSafe")) {
                localStorage.removeItem("scheduleSafe");
              }
              this.$router.push({
                path: `/dashboard/safeprojects`
              });
            }
            if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            console.log(err);
            this.loader = false;
          });
      } finally {
        // console.log("closed");
      }
    },
    getSavedData() {
      Api.getRequest(`getprojectunsaveddataforuser`)
        .then(res => {
          // console.log("saved data", res);
          this.saveDataServer = res.data;
          if (res.data.project != null) {
            this.title = res.data.project.title;
            this.projecttypeid = res.data.project.projecttypeid;
            this.projectdetails = res.data.project.projectdetails;
            this.modeofsafing = res.data.project.modeofsafing;
            this.fundtype = res.data.project.fundtype;
            this.amountforfixed = res.data.project.amountforfixed;
            this.handlerId = res.data.project.handler_id;
            this.handlerServiceId = res.data.project.service_id;
            this.futherInfo = res.data.project.futherInfo;
            this.startdate = res.data.project.startdate;
            this.enddate = res.data.project.enddate;
            this.projectid = res.data.project.id;
            this.specifytype = this.project.specifytype;
            this.maxamountforrange = res.data.project.maxamountforrange;
            this.minamountforrange = res.data.project.minamountforrange;
            this.calculateDate();
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    saveDataToContinue() {
      this.saving = true;
      let saveOption;
      const projectdata = {
        user_id: this.user.id,
        title: this.title,
        projecttypeid: this.projecttypeid,
        projectdetails: this.projectdetails,
        modeofsafing: this.modeofsafing,
        handler_id: this.handlerId,
        service_id: this.handlerServiceId,
        fundtype: this.fundtype,
        startdate: this.startdate,
        enddate: this.enddate,
        specifytype: this.specifytype
      };
      if (this.amountType === "fixed") {
        projectdata.amounttype = this.amountType;
        projectdata.amountforfixed = this.amountforfixed;
      } else {
        projectdata.amounttype = this.amountType;
        (projectdata.maxamountforrange = this.maxamountforrange),
          (projectdata.minamountforrange = this.minamountforrange);
      }
      if (this.saveDataServer.project == null) {
        saveOption = `saveforlaterfirsttime`;
      } else {
        saveOption = `saveforlaterothertimes`;
        projectdata.projectid = this.projectid;
      }
      if (this.futherInfo == "yes") {
        projectdata.futherInfo = "yes";
        projectdata.projecttypeid = this.projecttypeid;
      } else {
        projectdata.futherInfo = "no";
        projectdata.projecttypeid = this.projecttypeid;
      }
      // console.log("data", projectdata);
      // localStorage.setItem("_safeprojectdata", JSON.stringify(projectdata));
      Api.postRequest(`${saveOption}`, projectdata)
        .then(res => {
          this.saving = false;
          if (res.data.success) {
            this.$store.commit(
              "setApiSuccess",
              "Data saved, you can continue later"
            );
            this.$router.push({
              path: `/dashboard/safeprojects`
            });
            // this.getSavedData();
          }
          if (res.data.error) {
            this.$store.commit("setApiFailed", res.data.error);
          }
        })
        .catch(err => {
          console.log(err);
          this.saving = false;
        });
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format("MMMM Do YYYY, h:mm:ss a");
    }
  }
};
</script>

<style lang="scss" scoped>
$primary: #0033ea;
$secondary: #ffffff;
$yellow: #ffb100;
$tatiary: #a2b0e3;
$black: #000000;
$sheltaBlack: #262626;
$limeGreen: #3ec250;

@font-face {
  font-family: "Lato-Bold";
  src: local("Lato-Bold"),
    url("../assets/fonts/Lato/Lato-Bold.ttf") format("truetype");
}
@font-face {
  font-family: "Lato";
  src: local("Lato-Regular"),
    url("../assets/fonts/Lato/Lato-Regular.ttf") format("truetype");
}
@font-face {
  font-family: "Lato-light";
  src: local("Lato-Light"),
    url("../assets/fonts/Lato/Lato-Light.ttf") format("truetype");
}
@font-face {
  font-family: "Lato-bold-Italic";
  src: local("Lato-BlackItalic"),
    url("../assets/fonts/Lato/Lato-BlackItalic.ttf") format("truetype");
}
@font-face {
  font-family: "Lato-thin-Italic";
  src: local("Lato-ThinItalic"),
    url("../assets/fonts/Lato/Lato-ThinItalic.ttf") format("truetype");
}

@font-face {
  font-family: "Gotham";
  src: local("Gotham"),
    url("../assets/fonts/shelta_fonts/Gotham\ Book.otf") format("truetype");
}

.safe_text_holder {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.safe_text {
  img {
    background: #3059eb;
    border-radius: 3px;
    padding: 5px;
  }
  font-family: Gotham;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 30px;
  color: $black;
  span {
    color: #1765ca;
    cursor: pointer;
    padding-right: 5px;
  }
}

.holder {
  padding-bottom: 20px;
}
.projects_link {
  h6 {
    background: #3059eb;
    color: $secondary;
    padding: 5px 10px;
    font-family: Gotham;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 11px;
    border-radius: 4px;
    cursor: pointer;
    img {
      padding-right: 5px;
    }
  }
}

// New form for prjects start
.stepper {
  margin-bottom: 22px;
  h5 {
    font-family: Lato;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 150%;
    margin-top: 15px;
    text-align: left;
    color: $sheltaBlack;
    margin-bottom: 0;
    cursor: pointer;
    width: fit-content;
  }
  h6 {
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    color: $sheltaBlack;
    text-align: left;
    cursor: pointer;
    width: fit-content;
  }
}
.stepper-1 {
  height: 2px;
  background: #d5d8dd;
  // background: blue;
  border-radius: 50px;
}
.stepper-2 {
  height: 2px;
  background: #d5d8dd;
  // background: red;
  border-radius: 50px;
}
.activeStep {
  background: $primary !important;
}

.activeStepText {
  color: $primary !important;
}

.trigger-bittons {
  p {
    color: $sheltaBlack;
    font-family: Lato;
    font-style: normal;
    text-decoration: underline;
    padding-bottom: 5px;
    cursor: pointer;
    padding-top: 30px;
    font-size: 20px;
    width: fit-content;
    margin: auto;
  }
  // text-align: right;
  padding-top: 40px;
  padding-bottom: 100px;
  button {
    font-family: Lato;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 125%;
    box-shadow: none;
    outline: 0;
  }
  .continue-later {
    margin-right: 28px;
    width: 133px;
    height: 48px;
    border-radius: 6px;
    border: 1px solid $primary;
    color: $primary;
  }
  .next {
    width: 113px;
    height: 48px;
    background: $primary;
    border-radius: 6px;
    color: $secondary;
  }
  .prev {
    width: 113px;
    height: 48px;
    background: $secondary;
    border-radius: 6px;
    border: 1px solid $sheltaBlack;
    color: $sheltaBlack;
    margin-bottom: 10px;
    float: left;
    // display: flex;
    // text-align: left;
  }
}

.add-handler-btn {
  button {
    box-shadow: none;
    outline: 0;
    background: $primary;
    color: $secondary;
    font-family: Gotham;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    height: 45px;
  }
}
// New form for projects ends

.form_holder {
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  padding-top: 40px;
}

.project_info_text {
  h5 {
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 30px;
    text-align: left;
    color: $primary;
    padding: 15px 0 0 15px;
  }
}

input[type="radio"] {
  // transform:scale(1.5);
  width: 20px;
  height: 20px;
}

input[type="select"],
input[type="text"] {
  height: 39.68px;
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
}

.allocation_wrap {
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
}
.radio_wrap {
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.radio_wrap-2 {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.range_input {
  display: flex;
  // padding: 0 !important;
  input {
    margin: 0 10px;
    // border: 1px solid $primary !important;
    // height: 27.68px !important;
    margin-top: 15px;
  }
}

.info-tooltip {
  background: #d9d9d9;
  color: $primary;
  padding: 4px 10px;
  color: #fff;
  border-radius: 3px;
  position: absolute;
  top: 44px;
  right: 0px;
}
small[title]::after {
  background: red;
}

.tooltiptext {
  visibility: hidden;
  width: 225px;
  background: #f2f5fe;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  font-family: Lato;
  font-style: italic;
  font-weight: 300;
  font-size: 12px;
  line-height: 19px;
  display: flex;
  align-items: center;
  letter-spacing: -0.05em;
  color: $black;
  text-align: left;
  padding: 10px 10px;
  position: absolute;
  z-index: 1;
  top: 92%;
  right: 0;
  margin-left: -60px;
}

.info-tooltip + .tooltiptext::after {
  content: "";
  position: absolute;
  bottom: 100%;
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

.info-tooltip:hover + .tooltiptext {
  visibility: visible;
}

.radio-label {
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 30px;
  color: $black;
  display: flex;
  box-shadow: none;
  outline: 0;
}
.form-group > label {
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 30px;
  display: flex;
  color: #57595a;
}
.form-group {
  select,
  input {
    height: 39.68px;
    border: 0.7px solid #e5e5e5;
    border-radius: 5px;
    box-shadow: none;
    outline: 0;
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 30px;
    color: $sheltaBlack;
    // text-transform: capitalize;
  }
  textarea {
    // text-transform: lowercase;
    border: 0.7px solid #e5e5e5;
    border-radius: 5px;
    box-shadow: none;
    outline: 0;
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 30px;
    color: $sheltaBlack;
  }
}

.panel-input {
  position: relative;
  input {
    padding-right: 30px;
  }
  span {
    position: absolute;
    right: 5px;
    top: 46px;
    cursor: pointer;
    i {
      font-size: 11px;
    }
  }
}
.option-list {
  border: 0.7px solid #e5e5e5;
  border-top: 0;
  li {
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 30px;
    color: $sheltaBlack;
    list-style-type: none;
    cursor: pointer;
    text-align: left;
    padding: 0 15px;
  }
  li:hover {
    background: $primary;
    color: $secondary;
  }
  li:nth-child(even) {
  }
  li:nth-child(odd) {
  }
}
.handler-list {
  max-height: 150px;
  overflow-y: scroll;
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}
.activeHandler {
  background: $primary !important;
  color: $secondary !important;
}
.handler-list::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

.add-project-handler-trigger {
  p {
    color: $primary;
    border-top: 0.7px solid #e5e5e5;
    margin-bottom: 15px;
    text-align: left;
    padding: 15px 10px 0 30px;
    font-family: Lato;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    small {
      padding: 0;
      font-size: 22px;
      position: absolute;
      left: 11px;
      top: 10px;
    }
  }
}

.addHandlerModalContent {
  border-radius: 20px 20px 0px 0px !important;
}
.closeProjectHandler {
  display: flex;
  justify-content: space-between;
  padding: 10px 15px;
  align-items: baseline;
  background: #f0f6ff;
  border-radius: 20px 20px 0px 0px;
  h6 {
    font-family: Gotham;
    font-style: normal;
    font-weight: 500;
    font-size: 17px;
    line-height: 30px;
    color: $black;
  }
  small {
    font-family: Gotham;
    padding-left: 1px;
    text-align: center;
    // background: #c4c4c4;
    color: $black;
    font-size: 20px;
    // border-radius: 50px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.pro_details:first-letter {
  text-transform: capitalize !important;
}
.sc-btn {
  margin-top: 20px;
  margin-bottom: 10px;
  background: $primary;
  color: $secondary;
  font-family: Lato;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 30px;
  box-shadow: none;
  outline: 0;
}
.submit-btn {
  margin-top: 20px;
  margin-bottom: 10px;
  background: $yellow;
  color: $black;
  font-family: Lato;
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 30px;
  box-shadow: none;
  outline: 0;
  // margin-left: 10px;
}

.or {
  padding: 0 5px;
  position: relative;
  top: 6px;
  font-family: Lato;
  font-style: normal;
  font-size: 12px;
}

.add_project_option {
  // margin-top: 40px;
}

.summary_table {
  text-align: left;
  td {
    border-top: none;
    font-family: "Lato";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    // line-height: 40px;
    color: $black;
  }
  .bold-text {
    font-weight: bold;
  }
}
.break_down_text {
  padding: 10px 10px;
  font-family: Lato;
  font-style: italic;
  font-weight: 700;
  font-size: 14px;
  line-height: 30px;
  display: flex;
  align-items: center;
  color: $primary;
  margin-bottom: 0;
}

.breakdown_target {
  border: 0.7px solid #e5e5e5;
  border-radius: 5px;
  margin-bottom: 20px;
}

.goal_target {
  background: rgba(229, 229, 229, 0.2);
  // border: 0.7px solid #e5e5e5;
  // border-radius: 0px 5px 5px 0px;
  height: 100%;
  padding: 20px;
}

.goal_holder {
  padding-top: 45px;
  text-align: left;
  span {
    font-family: Lato;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 30px;
    color: $black;
    padding-left: 5px;
  }
  h1 {
    font-family: Lato;
    font-style: normal;
    font-weight: 400;
    font-size: 30px;
    line-height: 100%;
    color: $black;
    overflow-wrap: break-word;
    text-align: left;
  }
}

.goal_target2 {
  // height: 100%;
  // padding: 0 20px 20px;
}
.goal_holder2 {
  text-align: left;
  border: 1px solid #e2e8f0;
  border-radius: 10px 10px 0px 10px;
  padding: 29px 21px;
  span {
    font-family: Lato;
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 30px;
    color: $black;
    padding-left: 5px;
  }
  h1 {
    font-family: Lato;
    font-style: normal;
    // font-size: 30px;
    line-height: 100%;
    font-weight: 700;
    font-size: 37px;
    color: $primary;
    overflow-wrap: break-word;
    text-align: left;
    padding-top: 12px;
    small {
      font-weight: 700;
      font-size: 37px;
    }
  }
}
.breakdown-amount {
  margin-top: 40px;
  border: 1px solid #e2e8f0;
  border-radius: 10px 10px 0px 10px;
  padding-top: 16px;
  // padding-bottom: 10px;
  h6 {
    font-family: Lato;
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 125%;
    color: $sheltaBlack;
    margin-bottom: 8px;
    text-align: left;
    padding-left: 8px;
  }
}

.duration,
.duration-amount {
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 150%;
  color: $sheltaBlack;
  padding: 8px;
}

.duration {
  display: flex;
  justify-content: left;
}
.duration-amount {
  display: flex;
  justify-content: right;
}

::-webkit-input-placeholder {
  /* Edge */
  font-family: Lato;
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  line-height: 30px;
  color: #494747;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  font-family: Lato;
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  line-height: 30px;
  color: #494747;
}

::placeholder {
  font-family: Lato;
  font-style: italic;
  font-weight: 400;
  font-size: 12px;
  line-height: 30px;
  color: #494747;
}
/* Chrome, Safari, Edge, Opera */

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

@media only screen and (max-width: 599px) {
  .range_input {
    padding: 0 !important;
  }
  .goal_holder {
    padding-top: 0;
  }
  .radio_wrap-3 {
    display: block;
    margin-left: 15px;
    text-align: left;
  }
  .stepper {
    h6 {
      font-size: 13px;
    }
  }
  .trigger-bittons {
    padding-top: 20px;
    .continue-later, .next, .prev {
      // margin-right: 10px;
      width: 100%;
      display: block;
      margin-bottom: 10px;
    }
  }
  // .continue-later,
  // .next {
  //   display: block;
  //   width: 100%;
  //   margin-bottom: 10px;
  // }
}
</style>
